import React from "react";
import { Form, Button } from 'react-bootstrap';
import { useForm, SubmitHandler } from "react-hook-form";
import { toast } from 'react-toastify';
import * as Icon from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import '../assets/styles/resetPassword.scss';
import { resetPasswordApi } from '../services/api';
import { LocationInterface } from '../types/customTypes';
import * as base64json from 'base64json';

interface Props {
    location: LocationInterface["location"];
    history: string[];
}

type FormValues = {
    email: string;
    password: string;
    confirmPassword: string;
};

const ResetPassword:React.FC<LocationInterface> = (props: Props) => {
    const { register, handleSubmit } = useForm<FormValues>();
    const [error, setError] = useState<string>('');
    const [confirmError, setConfirmError] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [email, setEmail] = useState<string>('');

    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search);
        const token = queryParams.get('code');
        const { Email } = queryParams.get('detailCode') ? base64json.parse(queryParams.get('detailCode')) : {Email:''};
        setEmail(Email);
        if (!token || !Email) {
            toast.error('Invalid link');
            props.history.push('/');
        }
    }, [props.location.search]);

    const onSubmit: SubmitHandler<FormValues> = data => {
        if (!error && !confirmError) {
            const queryParams = new URLSearchParams(props.location.search);
            const token = queryParams.get('code');
            resetPasswordApi(email, data.password, token).then(async (response) => {
                const msg = await response.json();
                if (response.ok) toast.success(msg);
                else toast.error(msg);
                props.history.push('/login');
            }).catch(err => toast.error(err.toString()));
        }
    }

    const isPasswordValid = e => {
        e.preventDefault();
        const passwordValue = e.target.value;
        setPassword(passwordValue);

        const uppercasePassword = /(?=.*?[A-Z])/.test(passwordValue);
        const lowercasePassword = /(?=.*?[a-z])/.test(passwordValue);
        const digitsPassword = /(?=.*?\d)/.test(passwordValue);
        const specialCharPassword = /(?=.*?[!@#$%?&*\-_^+=()<>/~,.{}[\]|`])/.test(passwordValue);
        const nonWhitespaceRegExp = /(^\S*$)/.test(passwordValue);

        if (passwordValue.length < 8 || passwordValue.length > 20) setError("Password must be between 8 to 20 characters");
        else if (!nonWhitespaceRegExp) setError("White spaces are not allowed");
        else if (!uppercasePassword) setError("It should contain at least one uppercase");
        else if (!lowercasePassword) setError("It should contain at least one lowercase");
        else if (!specialCharPassword) setError("It should contain at least one special character");
        else if (!digitsPassword) setError("It should contain at least one digit");
        else setError('');
    };

    const isConfiPasswordValid = e => {
        if (password !== e.target.value) return setConfirmError('The passwords do not match');
        else return setConfirmError('');
    }

    return (
        <div className="resetPasswordForm">
            <Form className="form border shadow " id="form" data-testid="resetPasswordForm" onSubmit={handleSubmit(onSubmit)}>
                <div id="heading" className="title text-center"> Reset Password </div>
                <Form.Group className="mb-3 mx-4">
                    <Form.Label id="passwordLabel" > Password<em className="text-danger">*</em></Form.Label>
                    <div className="row">
                        <div className="col-11">
                            <Form.Control className={`${error ? "is-invalid form-control " : "form-control"}`} type="password" aria-describedby="basic-addon1"
                                id="password" data-testid="password" placeholder="Enter Password" {...register("password")} onChange={(e) => isPasswordValid(e)}
                                onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your password')}
                                onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required />
                        </div>
                        <div className="col-1 mt-1 tooltip-primary ps-0" data-toggle="tooltip" data-placement="right" title="Password should contain: &#013; At least 8 to 20 characters &#013;
                            At least one Uppercase letter &#013; At least one Lowercase letter &#013;
                            At least one Number &#013; At least one Special character &#013;&#013;">
                            <Icon.InfoCircle />
                        </div>
                    </div>
                   {error && <span id="errormsg" className='error text-danger mt-1 ms-1' >{error}</span>}
                </Form.Group>
                <Form.Group className="mb-3 mx-4">
                    <Form.Label > Confirm New Password<em className="text-danger">*</em></Form.Label>
                    <div className="row">
                        <div className="col-11">
                            <Form.Control type="password" id="password" data-testid="confirmPassword" placeholder="Enter Password" {...register("confirmPassword")}
                                onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your password')}
                                onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} onChange={(e) => isConfiPasswordValid(e)} required />
                            <span id="errormsg" className="error text-danger mt-1 ms-1" >{confirmError} </span>
                        </div>
                    </div>
                </Form.Group>
                <div className="text m-3">
                    <Button id="submit" className="btn-primary" type="submit"> Reset Password </Button>
                </div>
            </Form>
        </div>
    );
};

export default ResetPassword;
